import { trackSignUp } from '#utils/loginUtils';
import {
  hasVisitedSignupEnterpriseDemoTab,
  markSignupEnterpriseDemoTabVisited,
} from '#utils/signupEnterpriseDemoTabStorage';

const signUpIntentTabsAttr = { component: 'SignUpIntentTabs' };

export function trackSignupEnterpriseDemoTabSelected(): void {
  const isFirstVisit = !hasVisitedSignupEnterpriseDemoTab();
  markSignupEnterpriseDemoTabVisited();
  if (isFirstVisit) {
    trackSignUp('Sign Up Enterprise Demo Tab Selected', signUpIntentTabsAttr);
  }
}

function trackSignupTrialTabSelected(): void {
  trackSignUp('Sign Up Trial Tab Selected', signUpIntentTabsAttr);
}

export function trackSignupEnterpriseDemoFormSubmitted(): void {
  trackSignUp('Sign Up Enterprise Demo Form Submitted', { component: 'EnterpriseDemoSignupForm' });
}

export const SIGNUP_TAB_TRIAL = 'trial';
export const SIGNUP_TAB_ENTERPRISE_DEMO = 'enterprise-demo';

export function handleSignupIntentTabChange(previousTab: string, nextTab: string): void {
  if (nextTab === SIGNUP_TAB_ENTERPRISE_DEMO) {
    trackSignupEnterpriseDemoTabSelected();
    return;
  }

  if (
    nextTab === SIGNUP_TAB_TRIAL &&
    previousTab === SIGNUP_TAB_ENTERPRISE_DEMO &&
    hasVisitedSignupEnterpriseDemoTab()
  ) {
    trackSignupTrialTabSelected();
  }
}

export function getSignupTrialSubmitAnalyticsProps(): { visitedEnterpriseDemoTab: boolean } {
  return { visitedEnterpriseDemoTab: hasVisitedSignupEnterpriseDemoTab() };
}
